import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../data/User';
import { HaloLoaderService } from '../halo-loader/halo-loader.service';
import { RootScopeDeclare } from '../rootscope-declare';
import { RootScopeService } from '../shared-service/root-scope.service';
import { CommonUtil } from '../Utils/common-util';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private vtTokenKey: string | null;
  private user: User | null;
  rootScopeData: RootScopeDeclare;
  returnToParam: any;
  brandingIdParam: any;
  urlParams: URLSearchParams;
  zendeskToken: string;
  message: string | null;
  private _autoLogOutSubscriber= new BehaviorSubject<boolean>(false);
  public autoLogOutSubscriber = this._autoLogOutSubscriber.asObservable();
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private rootScopeService: RootScopeService,
    private translateService: TranslateService,
    private loader: HaloLoaderService,
    public commonUtil: CommonUtil,
    private router: Router
  ) {
    this.urlParams = new URLSearchParams(window.location.search);
    this.returnToParam = this.urlParams.get('return_to');
    this.brandingIdParam = this.urlParams.get('brand_id');
    this.message = this.urlParams.get('message');
    this.reCheckVtTokenKey();
    this.getRootScopeData();
  }

  getAutoLogOutFlag(){
    return this._autoLogOutSubscriber.getValue();
  }

  updateAutoLogOutFlag(status:boolean) {
    this._autoLogOutSubscriber.next(status);
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  signoutReset() {
    this.user = null;
    this.reCheckVtTokenKey();
  }
  reCheckVtTokenKey() {
    this.vtTokenKey = null;
    if (sessionStorage.getItem('vtTokenKey') != null) this.vtTokenKey = sessionStorage.getItem('vtTokenKey');
    else this.vtTokenKey = localStorage.getItem('vtTokenKey');

    const cookieToken = this.cookieService.get('vtTokenKey');
    if (this.vtTokenKey == null || this.vtTokenKey == undefined || this.vtTokenKey == '') {
      if (cookieToken != null) {
        localStorage.setItem('vtTokenKey', cookieToken);
        this.vtTokenKey = cookieToken;
      }
    }
  }

  isAuthenticated() {
    this.reCheckVtTokenKey();
    return !!this.vtTokenKey;
    // if (this.vtTokenKey == null || this.vtTokenKey == undefined || this.vtTokenKey == '') {
    //   return false;
    // } else {
    //   return true;
    // }
  }

  authenticateUser() {
    this.reCheckVtTokenKey();
    if (this.isAuthenticated() && this.user == null) {
      // Add delay to fix hybrid authentication
      setTimeout(() => this.getUserAccount(false, this.vtTokenKey), 2000);
    }
    /*
    uncommenting this would login to the application even if sso login fails
    else if (this.cookieService.get('ssoCookie')) {
      let ssoToken = this.cookieService.get('ssoCookie');
      this.getUserAccount(true, ssoToken);
    }*/
  }

  createAuthorizationHeader(headers: HttpHeaders, vtTokenKey: string | null) {
    headers = headers.set('Authorization', 'Bearer ' + vtTokenKey);
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }

  authHeader() {
    const header = new HttpHeaders();
    return header.set('Authorization', 'Bearer ' + this.vtTokenKey);
  }

  getUserAccount(isSsoCookie: boolean, vtTokenKey: string | null) {
    if (this.returnToParam != null) {
      localStorage.setItem('zendeskReturnToUrl', this.returnToParam);
      if (this.message != null) { localStorage.setItem('zendesklogoutMessage', this.message); }
    }

    let headers = new HttpHeaders();
    headers = this.createAuthorizationHeader(headers, vtTokenKey);
    this.http
      .post<User>(environment.servicePath + '/lfuser/get_account', vtTokenKey, { headers: headers })
      .subscribe(
        data => {
          this.updateAutoLogOutFlag(false);
          if(data.tokenExpiryAt){
            localStorage.setItem('tokenExpiryAt', data.tokenExpiryAt);
            this.autoLogoutListener(data.tokenExpiryAt);
          }
          this.user = new User(data);
          this.rootScopeData.currentUser = this.user;
          this.rootScopeData.profileImageUrl = this.user.profileImageUrl;
          this.rootScopeData.selectedLang = this.user.preferredLanguage;
          this.rootScopeData.preferredUnit = this.user.preferredUnit.toString();
          this.zendeskToken = data.zendeskToken;
          localStorage.setItem('selectedLang', this.rootScopeData.selectedLang);
          this.translateService.use(this.rootScopeData.selectedLang);
          if (this.rootScopeData.selectedLang === 'ar' || this.rootScopeData.selectedLang === 'he') {
            this.rootScopeService.changeToRtl();
          } else {
            this.rootScopeService.changeToLtr();
          }

          this.cookieService.delete('ssoCookie');
          if (isSsoCookie) {
            this.vtTokenKey = vtTokenKey;
            if (this.vtTokenKey)
              this.cookieService.set('vtTokenKey', this.vtTokenKey, 0, '', '', true, 'None');

            this.cookieService.delete('ssoCookie');
            const staySigned = this.cookieService.get('staySignedIn');
            if (this.vtTokenKey) {
              if (staySigned === 'true') {
                localStorage.setItem('vtTokenKey', this.vtTokenKey);
              } else {
                sessionStorage.setItem('vtTokenKey', this.vtTokenKey);
              }
            }
            this.cookieService.delete('staySignedIn');
          }

          this.rootScopeData.isAuthenticated = this.isAuthenticated();
          if (localStorage.getItem('zendeskReturnToUrl') != null && localStorage.getItem('zendesklogoutMessage') === null) {
            const zendeskParams = encodeURIComponent('?jwt=' + this.zendeskToken + '&return_to=' + localStorage.getItem('zendeskReturnToUrl'));
            localStorage.removeItem('zendeskReturnToUrl');
            window.location.href = 'https://halofitness.zendesk.com/access/jwt' + decodeURIComponent(zendeskParams);

          }
          else if (localStorage.getItem('zendesklogoutMessage') != null) {
            localStorage.removeItem('zendesklogoutMessage');
            localStorage.removeItem('zendeskReturnToUrl');

          }
          //this.commonUtil.redirectBasedOnAuthentication();
         
         
        },
        error => {
          this.vtTokenKey = null;
          this.loader.resetProcess();
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('vtTokenKey');
          localStorage.removeItem('vtUserType');
          localStorage.removeItem('vtManagerType');
          localStorage.removeItem('ssoFederated');
          localStorage.removeItem('newEquipmentAdded');
          localStorage.removeItem('isSsoFederated');
          localStorage.removeItem('lefNavigationExpandStatus');
          localStorage.removeItem('tokenExpiryAt');
          sessionStorage.removeItem('vtTokenKey');
          sessionStorage.removeItem('hideSurveyPopup');
          sessionStorage.removeItem('hideOutdatedOnboardingPopup');

          this.cookieService.delete('vtTokenKey');
          this.cookieService.delete('ssoCookie');
          this.cookieService.delete('staySignedIn');
          this.cookieService.delete('ssoFederated');
          this.cookieService.delete('ssolang');
          this.cookieService.delete('vtManagerType');
          this.cookieService.delete('vtUserType');
          this.cookieService.delete('isSsoFederated');
          this.cookieService.delete('vtImpersonatorTokenKey');
          this.router.navigate(['/login']);
        }
      );
  }

   async autoLogoutListener(expiryTimeOut:string){
     const currentMilli = new Date().getTime();
     const remainingMilli = Number(expiryTimeOut) - Number(currentMilli)
     await this.timeout(Number(remainingMilli));
     this.loader.resetProcess();
     this.updateAutoLogOutFlag(true);
  }

  timeout(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  getURLparams() {
    return (<any>window)['urlParams'];
  }

  sosErrorCheckOnURLparams() {
    const urlParams = this.getURLparams();
    return ('p_error_codes_list' in urlParams || 'p' in urlParams || 'p_error_code' in urlParams)
  }

  distroyURLparams() {
    (<any>window)['urlParams'] = {};
  }
}
